import React, { useEffect } from "react";
import "./style.scss";
import Heading from "../../elements/heading";
import LoginForm from "../../sections/login-form";
import PrimaryButton from "../../elements/primary-button";
import InfoPanel from "../../sections/info-panel";
import HeroAccount from "../../sections/hero-account";
import PropTypes from "prop-types";
import { S_AUTH_TOKEN, S_LANG, webStorage } from "../../utils/webStorage";
import { useDispatch, useSelector } from "react-redux";
import { LOGOUT } from "../../redux/actions";
import useQuery from "../../utils/useQuery";
import { useHistory } from "react-router-dom";
import { canUseDOM } from "../../utils";
import { clearGearCheckoutAction } from "../../redux/actions/gears-checkout";
import { staffInfoSelector } from "../../selectors/application";
import useAccountLogin from "../../hooks/useAccountLogin";
import { isLoggedIn } from "../../services/siteService";

const isSSR = !canUseDOM();
const Login = ({ match, rendering, fields }) => {
  /*Redux start*/
  const dispatch = useDispatch();
  const staffInfo = useSelector(staffInfoSelector);
  const logout = () => dispatch({ type: LOGOUT });
  const clearGearCheckout = () => dispatch(clearGearCheckoutAction());
  /*Redux end*/
  const lang = webStorage.get(S_LANG);
  const { heroAccount, loginForm, infoPanel, newUserTitleType, newUserTitleBody, newUserBody, newUserCTA, loginSuccessRedirectUrl } = fields;
  const createAccountBox = !isSSR
    ? {
        heading: { type: newUserTitleType, html: newUserTitleBody },
        body: newUserBody.value,
        createAccount: {
          ...newUserCTA.fields,
          link: {
            value: {
              ...newUserCTA.fields.link.value,
              href: newUserCTA.fields.link.value.href + window.location.search
            }
          }
        }
      }
    : {
        heading: { type: newUserTitleType, html: newUserTitleBody },
        body: newUserBody.value,
        createAccount: {
          ...newUserCTA.fields
        }
      };

  const query = useQuery();
  const history = useHistory();
  const { loginFailed, loginWrongEmailOrPassword, loginNetworkError, loginAccountLock, temporaryLock, login } = useAccountLogin();
  useEffect(() => {
    if (query.action === "logout" || staffInfo) {
      logout();
    }
  }, []);

  useEffect(() => {
    if (isLoggedIn()) {
      loginRedirect();
    }
  }, []);

  const loginRedirect = () => {
    const token = webStorage.get(S_AUTH_TOKEN);
    if (query.redirect) {
      if (query.redirect.startsWith("https://") || query.redirect.startsWith("http://")) {
        global.location.href = `${query.redirect}?token=${token.accessToken}`;
      } else {
        history.replace(query.redirect);
      }
    } else if (loginSuccessRedirectUrl.value) {
      history.replace(loginSuccessRedirectUrl.value.href);
    }
  };
  const submitLogin = async (evt, data) => {
    const res = await login(data.email, data.password);
    const userInfo = res ? res.userInfo : {};
    if (userInfo) {
      clearGearCheckout();
      //** Measurements */
      let dataLayer = window.dataLayer || [];
      let membershipLevel = "";

      switch (userInfo.membershipCode) {
        case "MEMBERSHIP01":
          membershipLevel = "Level0";
          break;
        case "MEMBERSHIP02":
          membershipLevel = "Level1";
          break;
        case "MEMBERSHIP03":
          membershipLevel = "Level2";
          break;
        case "MEMBERSHIP04":
          membershipLevel = "Level3";
          break;
      }

      dataLayer.push({
        event: "accountLogin",
        eventCategory: "account",
        eventAction: "login",
        eventLabel: membershipLevel
      });
      loginRedirect();
    }
  };

  return (
    <div className="login grid" datasourceid={rendering.dataSource}>
      <HeroAccount {...heroAccount.fields} />
      <LoginForm
        {...{
          ...loginForm.fields,
          loginFailed,
          loginNetworkError,
          loginAccountLock,
          temporaryLock,
          loginWrongEmailOrPassword,
          lang,
          match,
          submitLogin: (evt, data) => submitLogin(evt, data)
        }}
      />
      <CreateAccount {...createAccountBox} />
      <InfoPanel {...infoPanel.fields} />
    </div>
  );
};

const CreateAccount = ({ heading, body, createAccount }) => {
  return (
    <div className="create-account-section">
      <div className="contnet-container">
        <Heading type={heading.type} className="title" html={heading.html} typographyClass={heading.typographyClass ? heading.typographyClass : "type-h3"} />
        {body && (
          <div
            className="body-text"
            dangerouslySetInnerHTML={{
              __html: body
            }}
          />
        )}
        {createAccount && <PrimaryButton {...createAccount} />}
      </div>
    </div>
  );
};
export default Login;

Login.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    heroAccount: PropTypes.object,
    loginForm: PropTypes.object,
    infoPanel: PropTypes.object,
    newUserTitleType: PropTypes.object,
    newUserTitleBody: PropTypes.object,
    newUserBody: PropTypes.shape({ value: PropTypes.string }),
    newUserCTA: PropTypes.object
  })
};
